<template>
  <div class="space-y-4">
    <ReviewRater class="h-8" v-model="form.rating" no-clear :disabled />
    <SelectSingleList
      :modelValue="form.language"
      @update:modelValue="(lang) => updateReviewLanguage(lang)"
      :options="languages"
      label="Review Language"
      :disabled
    />
    <NamiTextArea v-model="reviewMessage" label="Write a review" :disabled />
    <div class="flex justify-end space-x-2">
      <NamiButton
        v-if="form.reviewMeta"
        buttonType="secondary"
        small
        @buttonClick="emit('cancel')"
        :disabled
      >
        Cancel
      </NamiButton>
      <NamiButton
        v-if="authStore?.user"
        buttonType="primary"
        :icon="IconSend"
        small
        @buttonClick="emit('submit')"
        :disabled
        :loading
      >
        Submit
      </NamiButton>
      <NamiButton
        v-else
        buttonType="primary"
        small
        @buttonClick="doLogin"
        :disabled
      >
        Log in to write a review
      </NamiButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TitleReviewForm } from "~/types/forms/titleReview";
import { IconSend } from "@tabler/icons-vue";
import { type AvailableLanguages, getLanguages } from "~/src/api";

defineProps<{
  disabled?: boolean;
  loading?: boolean;
}>();

const emit = defineEmits<{
  (e: "submit"): void;
  (e: "cancel"): void;
}>();

const form = defineModel<TitleReviewForm>("reviewForm", { required: true });
const languages = getLanguages();
const nuxtApp = useNuxtApp();
const authStore = nuxtApp.$auth();

const reviewMessage = computed({
  get() {
    return form.value.message[form.value.language] ?? "";
  },
  set(value) {
    form.value.message[form.value.language] = value;
  },
});

const updateReviewLanguage = (lang: AvailableLanguages) => {
  const message = form.value.message[form.value.language];
  delete form.value.message[form.value.language];
  form.value.message[lang] = message;
  form.value.language = lang;
};
</script>
